module.exports = __webpack_public_path__ + "img/headline_img.7e7a5fec.png";